import { StyledMaintenancePage } from './style';
import { useIntl } from 'react-intl';

const MaintenancePage = () => {
  const intl = useIntl();

  return (
    <StyledMaintenancePage>
      <div className={'content'}>
        <p className={'description'}>
          {intl.formatMessage({ id: 'maintenance.description' })}
        </p>
        <p className={'subtitle'}>
          {intl.formatMessage({ id: 'maintenance.subtitle' })}
        </p>
      </div>
    </StyledMaintenancePage>
  );
};

export default MaintenancePage;
